<template>
  <el-tooltip content="英法句子分析" placement="bottom">
    <img class="func-img" src="@/assets/img/note.png" @click="onClick" />
  </el-tooltip>
</template>

<script>
export default {
  name: 'EnglishParseMenuButton',

  props: ['isActive'],

  methods: {
    onClick (e) {
      this.$emit('click', (text) => {
        // 英法句子分析不需要发送给AI聊天，直接显示解析结果
        console.log('英法句子分析结果:', text)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.func-img{
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
}
</style> 